export default __webpack_public_path__ + "static/media/affligem_background_m1.a857360a.jpg";